import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSchool"><Path fillRule="evenodd" clipRule="evenodd" d="M8.5 4C7.11929 4 6 5.11929 6 6.5V19H5V8H4.5C3.11929 8 2 9.11929 2 10.5V19H1.5C1.22386 19 1 19.2239 1 19.5C1 19.7761 1.22386 20 1.5 20H22.5C22.7761 20 23 19.7761 23 19.5C23 19.2239 22.7761 19 22.5 19H22V10.5C22 9.11929 20.8807 8 19.5 8H19V19H18V6.5C18 5.11929 16.8807 4 15.5 4H8.5ZM14 16.5V19H10V16.5C10 15.6716 10.6716 15 11.5 15H12.5C13.3284 15 14 15.6716 14 16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSchool;
